/**
 * <TutorApplicationChampionAsks> — le champion d'une étape de la candidature pose sa question (molecule).
 *
 * L'ancien `InterviewScreen` faisait poser chaque question par le champion de l'étape, entier, dans sa
 * bulle ; la règle « un champion qui parle se montre en pied, avec sa bulle » (`CLAUDE.md`) le garde. Le champion à gauche, la question dans sa bulle à côté, la queue vers lui ; la bulle se
 * lève au-dessus de ses pieds, à hauteur de sa tête. Lu par l'entretien écrit et par la réflexion d'une
 * question vidéo, qui passent l'en-tête au nom de l'étape (`UITutorApplicationAsker.stepTitle`).
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { type ChampionName } from "../../atoms/Avatar/ChampionAvatar"
import { ChampionFigure } from "../../atoms/ChampionFigure"
import { Row } from "../../atoms/containers/Row"
import { Text } from "../../atoms/typography/Text"
import { SPEECH_BUBBLE_LIFT, SpeechBubble } from "../SpeechBubble"

/** Assez grand pour qu'il soit entier, sans pousser les réponses hors de l'écran. */
export const TUTOR_APPLICATION_ASKER_HEIGHT = 112

export type TutorApplicationChampionAsksProps = {
    champion: ChampionName
    question: string
    testID?: string
}

/** Mémorisé : la réflexion qui l'entoure se re-rend à chaque seconde du décompte. */
export const TutorApplicationChampionAsks = React.memo(function TutorApplicationChampionAsks(
    props: TutorApplicationChampionAsksProps
) {
    const { champion, question, testID } = props
    return (
        <Row gap="2" align="end" testID={testID}>
            <ChampionFigure name={champion} height={TUTOR_APPLICATION_ASKER_HEIGHT} />
            <View style={styles.bubble}>
                <SpeechBubble tail="left">
                    <Text size="text-lg" weight="semibold" color="text-primary" accessibilityRole="header">
                        {question}
                    </Text>
                </SpeechBubble>
            </View>
        </Row>
    )
})

const styles = StyleSheet.create((theme) => ({
    bubble: { flex: 1, minWidth: 0, paddingBottom: theme.spacing[SPEECH_BUBBLE_LIFT] },
}))
